const postsViewContainer = (theme) => ({
  postsViewContainer: {
    width: "100%",
    height: "fit-content",
    [theme.breakpoints.down("xs")]: {},
    [theme.breakpoints.up("sm")]: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
    },
  },
  pagenation: {
    display: "flex",
    justifyContent: "center",
    "&>ul": {
      display: "flex",
      justifyContent: "center",
    },
  },
  pagenationItem: {
    color: "#999999",
    backgroundColor: "#ffffff",
    boxShadow: "0 3px 3px 3px rgba(0, 0, 0, 0.6)",
    transition: "all .5s ease",
    "&:hover": {
      color: "#ffffff",
      backgroundColor: "#3f51b5",
      boxShadow: "0 9px 3px 3px rgba(0, 0, 0, 0.6)",
    },
  },
});
export default postsViewContainer;
